module.exports = __webpack_public_path__ + "img/icon3.c047e22a.png";